/**
 * Workspace Analytics Type Definitions
 *
 * TypeScript interfaces matching the backend Pydantic schemas
 * for workspace analytics and metrics.
 */

export interface TokenUsageStats {
  tokens_used: number;
  monthly_limit: number | null;
  usage_percentage: number;
  remaining_tokens: number | null;
}

export interface UserActivityStats {
  user_id: number;
  user_name: string;
  user_email: string;
  session_count: number;
  tokens_used: number;
}

export interface AgentUsageStats {
  agent_id: number;
  agent_name: string;
  usage_count: number;
}

export interface WorkspaceAnalytics {
  workspace_id: number;
  workspace_name: string;
  period_days: number;
  period_start: string;
  period_end: string;

  // Token usage metrics
  token_usage: TokenUsageStats;

  // User activity metrics
  user_activity: UserActivityStats[];
  total_active_users: number;

  // Agent usage metrics
  agent_usage: AgentUsageStats[];
  total_agents: number;

  // Resource counts
  total_knowledge_bases: number;
  total_data_sources: number;
  total_members: number;

  // Session statistics
  total_sessions: number;
}

export interface TokenHistoryPoint {
  date: string;
  tokens: number;
}

/**
 * Period selector values (in days)
 */
export type MetricsPeriod = 7 | 30 | 90;

/**
 * Period label mapping for UI
 */
export const METRICS_PERIOD_LABELS: Record<MetricsPeriod, string> = {
  7: 'Últimos 7 dias',
  30: 'Últimos 30 dias',
  90: 'Últimos 90 dias',
};
